import salaBalowa from "src/assets/img/studio/sala-balowa.webp";

import salaBalowaAlt from "src/assets/img/atelier/salaBalowa.webp";
import salaKominkowaAlt from "src/assets/img/atelier/salaKominkowa.webp";
import salaOgrodowaAlt from "src/assets/img/atelier/salaOgrodowa.webp";
import salaTarasowaAlt from "src/assets/img/atelier/salaTarasowa.webp";

export default function Sale() {

	return (
		<main className="sale">
			<section className="sale__main main">
				<div className="main__container">
				<div className="main__image-block">
					<img src={salaBalowa} alt="Sala Balowa"></img>
					<h1 className="main__title">Sale do wynajęcia</h1>
				</div>
				</div>
			</section>
			<section className="sale__atelier atelier">
          <div className="atelier__container">
            <div className="atelier__blocks blocks">
              <div className="blocks__block block">
                <div className="block__image">
                  <img src={salaBalowaAlt} alt="Sala balowa"></img>
                </div>
                <h4 className="block__title">Sala balowa</h4>
                <div className="block__text">
                  Największa sala naszego studia fotograficznego. Jej cechą
                  charakterystyczną jest piękny fortepian w kolorze brązowym.
                  Ponad to znaleźć tu można wiele unikalnych dodatków, które
                  nadają Waszym dziełom charakteru i elegancji. Stylowy klimat i
                  miejsce, które ma swoją historię.
                </div>
              </div>
              <div className="blocks__block block">
                <div className="block__image">
                  <img src={salaKominkowaAlt} alt="Sala kominkowa"></img>
                </div>
                <h4 className="block__title">Sala kominkowa</h4>
                <div className="block__text">
                  Cała w drewnie, z kominkiem, wyjątkową podłogą o szczotkowanej
                  strukturze. Kominek kojarzy się z romantyzmem, umieszczenie go
                  w kadrze może dodać zdjęciu głębi i emocji. Zdjęcia z
                  kominkiem przenoszą do czasów innej epoki, a nawet w inny
                  wymiar. Ta sala idealnie się nadaje do sesji wizerunkowych,
                  kobiecych czy sezonowych (aranżacja świąteczna).
                </div>
              </div>
              <div className="blocks__block block">
                <div className="block__image">
                  <img src={salaOgrodowaAlt} alt="Sala ogrodowa"></img>
                </div>
                <h4 className="block__title">Sala ogrodowa</h4>
                <div className="block__text">
                  Posiada marmurową wannę na lwich łapach oraz mniejsze
                  aranżacje i duże lustro. Sala ogrodowa połączona jest z
                  ogrodem zimowym, w którym znajdują się duże okna, dzięki temu
                  mamy światła. Okna (otwierane pionowo) mogą też stanowić
                  ciekawy element kompozycji, tworząc kontrast między wnętrzem a
                  zewnętrzem, lub służyć jako ramy dla modeli. Sala ma piękny
                  francuski balkonik, podwójnie rozsuwane drzwi i „lewitujące”
                  kwiaty.
                </div>
              </div>
              <div className="blocks__block block">
                <div className="block__image">
                  <img src={salaTarasowaAlt} alt="Sala tarasowa"></img>
                </div>
                <h4 className="block__title">Sala tarasowa</h4>
                <div className="block__text">
                  Minimalistyczna sala z parkietem, z dużą ilością płóciennych
                  teł Canvas ręcznie malowanych, szezlongiem czy antyczną
                  witryną. Idealne miejsce do tworzenia nastrojowych i
                  artystycznych zdjęć portretowych. Sala z otwartym tarasem
                  zapewnia pełen dostęp do promieni słonecznych, co pozwala na
                  uzyskanie naturalnego i ciepłego oświetlenia zdjęć.
                </div>
              </div>
            </div>
          </div>
        </section>
		</main>
	)
}